var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.obj_to_null(_vm.cur_item)
    ? _c(
        "div",
        { staticClass: "categ_info" },
        [
          _c("info_field", {
            attrs: {
              f_uniq: "cid",
              f_title: _vm.__t("UNIQ_GO_CODE"),
              f_val: _vm.cur_item.id.toString(),
            },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_type: "uniq_id",
              f_uniq: "cid2",
              f_title: _vm.__t("UNIQ_CODE"),
              f_val: _vm.cur_item.uniq_id.toString(),
            },
            on: { update_categ: _vm.change_atr },
          }),
          _vm._v(" "),
          _vm.is_google_review
            ? _c("div", { staticClass: "google_actions mb-4" }, [
                _c("div", { staticClass: "d-flex" }, [
                  _vm.google_location_url
                    ? _c(
                        "a",
                        {
                          staticClass: "btn btn-sm btn-outline-primary mr-2",
                          attrs: {
                            href: _vm.google_location_url,
                            target: "_blank",
                            rel: "noopener noreferrer",
                          },
                        },
                        [
                          _c("i", { staticClass: "fab fa-google mr-1" }),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.__t("OPEN_GOOGLE_LOCATION")) +
                              "\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.google_review_url
                    ? _c(
                        "a",
                        {
                          staticClass: "btn btn-sm btn-outline-info",
                          attrs: {
                            href: _vm.google_review_url,
                            target: "_blank",
                            rel: "noopener noreferrer",
                          },
                        },
                        [
                          _c("i", { staticClass: "fal fa-comment-alt mr-1" }),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.__t("OPEN_GOOGLE_REVIEW")) +
                              "\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.has_reply
            ? _c("div", { staticClass: "reply_action mb-4" }, [
                _vm.has_successful_reply && !_vm.is_reply_form_open
                  ? _c("div", { staticClass: "alert alert-success mb-3" }, [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mb-2" },
                        [
                          _c("i", { staticClass: "fal fa-check-circle mr-2" }),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.__t("REPLY_ALREADY_SENT")) +
                                "\n                "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.original_reply_text
                        ? _c("div", { staticClass: "reply_existing_text" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.original_reply_text) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-md btn-block btn-outline-info waves-effect waves-themed",
                    attrs: { type: "button", disabled: _vm.is_reply_load },
                    on: { click: _vm.make_reply },
                  },
                  [
                    _c("span", {
                      staticClass: "fal mr-1",
                      class: _vm.is_reply_form_open ? "fa-times" : "fa-reply",
                    }),
                    _vm._v(
                      "\n\n            " +
                        _vm._s(
                          _vm.is_reply_form_open
                            ? _vm.__t("CANCEL")
                            : _vm.has_successful_reply
                            ? _vm.__t("UPDATE_REPLY")
                            : _vm.__t("REPLY")
                        ) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.is_reply_form_open
                  ? _c("div", { staticClass: "reply_form mt-3" }, [
                      _c("div", { staticClass: "form-group mb-2" }, [
                        _c("label", { staticClass: "form-label" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.__t("REPLY_TO_REVIEW")) +
                              "\n                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.reply_text,
                              expression: "reply_text",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            rows: "5",
                            maxlength: "4096",
                            disabled: _vm.is_reply_load,
                            placeholder: _vm.__t("ENTER_REVIEW_REPLY"),
                          },
                          domProps: { value: _vm.reply_text },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.reply_text = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "d-flex justify-content-between mt-1",
                          },
                          [
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.reply_text.length) +
                                  " / 4096\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.has_successful_reply
                              ? _c("small", { staticClass: "text-success" }, [
                                  _c("i", {
                                    staticClass: "fal fa-check-circle mr-1",
                                  }),
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.__t("REPLY_ALREADY_SENT")) +
                                      "\n                    "
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary btn-block waves-effect waves-themed",
                          attrs: {
                            type: "button",
                            disabled: !_vm.can_send_reply,
                          },
                          on: { click: _vm.send_reply },
                        },
                        [
                          _vm.is_reply_load
                            ? _c("span", {
                                staticClass:
                                  "spinner-border spinner-border-sm mr-1",
                                attrs: { role: "status" },
                              })
                            : _c("span", {
                                staticClass: "fal fa-paper-plane mr-1",
                              }),
                          _vm._v(
                            "\n\n                " +
                              _vm._s(
                                _vm.has_successful_reply
                                  ? _vm.__t("UPDATE_REPLY")
                                  : _vm.__t("SEND_REPLY")
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "customer_name",
              f_title: _vm.__t("AUTHOR"),
              f_val: _vm.cur_item.customer_name.toString(),
            },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "customer_phone",
              f_title: _vm.__t("PHONE"),
              f_val: _vm.cur_item.customer_phone.toString(),
            },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "ratio",
              f_title: _vm.__t("RATIO"),
              f_val: _vm.cur_item.ratio.toString(),
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "review-comment" } },
              [
                _vm._v(
                  "\n            " + _vm._s(_vm.__t("COMMENT")) + "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "input-group" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.cur_item.description,
                    expression: "cur_item.description",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  id: "review-comment",
                  disabled: "",
                  rows: "7",
                  "aria-label": "Review comment",
                },
                domProps: { value: _vm.cur_item.description },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.cur_item, "description", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "source",
              f_title: _vm.__t("SOURCE"),
              f_val: _vm.source_name,
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "review-date" } },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.__t("DATE_CREATE")) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "input-group" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.cur_item.added,
                    expression: "cur_item.added",
                  },
                ],
                staticClass: "form-control",
                attrs: { id: "review-date", type: "text", disabled: "" },
                domProps: { value: _vm.cur_item.added },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.cur_item, "added", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text text-success" }, [
        _c("i", { staticClass: "fal fa-calendar-edit fs-xl" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }